import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { RegisterCardReaderComponent } from './register-card-reader.component';
import {SalonMonsterLoadMaskModule} from "../../../../components/smr-load-mask/smr-load-mask.module";
import {SalonMonsterCheckMarkLoaderModule} from "../../../../components/smr-checkmark-loader/smr-checkmark-loader.module";


@NgModule({
  declarations: [
    RegisterCardReaderComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    SalonMonsterLoadMaskModule,
    SalonMonsterCheckMarkLoaderModule,
  ]
})
export class RegisterCardReaderComponentModule {}
